import {
	type GetInboundDocumentAvailableTargetsQuery,
	type GetInboundDocumentQuery,
	type GetInboundDocumentsQuery,
	type GetInboundIntakeSettingsQuery
} from "~/gql/queries/inboundDocuments.generated";

const inboundDocumentEndpoints = {
	AddInboundAllowedSender: {
		invalidatesTags: ["InboundIntakeSettings"] as AddTagTypes
	},
	DiscardInboundDocument: {
		invalidatesTags: ["InboundDocuments"] as AddTagTypes
	},
	GetInboundDocument: {
		providesTags: ["InboundDocuments"] as AddTagTypes,
		transformResponse: (res: GetInboundDocumentQuery) => res
	},
	GetInboundDocumentAvailableTargets: {
		providesTags: ["InboundDocuments"] as AddTagTypes,
		transformResponse: (res: GetInboundDocumentAvailableTargetsQuery) => res
	},
	GetInboundDocuments: {
		providesTags: ["InboundDocuments"] as AddTagTypes,
		transformResponse: (res: GetInboundDocumentsQuery) => res
	},
	GetInboundIntakeSettings: {
		providesTags: ["InboundIntakeSettings"] as AddTagTypes,
		transformResponse: (res: GetInboundIntakeSettingsQuery) => res
	},
	RemoveInboundAllowedSender: {
		invalidatesTags: ["InboundIntakeSettings"] as AddTagTypes
	},
	RotateInboundIntakeAddress: {
		invalidatesTags: ["InboundIntakeSettings"] as AddTagTypes
	},
	RouteInboundDocument: {
		invalidatesTags: ["InboundDocuments"] as AddTagTypes
	},
	SetInboundDocumentKind: {
		invalidatesTags: ["InboundDocuments"] as AddTagTypes
	},
	UpdateInboundDocumentSettings: {
		invalidatesTags: ["InboundIntakeSettings"] as AddTagTypes
	}
};

export default inboundDocumentEndpoints;
